export type RecipientDrawerFlow =
  | "ach"
  | "wire"
  | "internationalWire"
  | "settings";

export type RecipientPaymentMethod = "ach" | "wire" | "internationalWire";

interface RecipientDrawerFlowConfig {
  // the method the recipient must have before the drawer hands it back
  requiredMethod: RecipientPaymentMethod | null;
  // "view" keeps the drawer open on the saved recipient, "close" hands it back
  afterSave: "close" | "view";
  // fluent id of the toast shown when the drawer closes without the required method
  missingMethodToastId: string | null;
}

// payment method sections in display order, the same in every flow (Profile always comes first)
export const RECIPIENT_PAYMENT_METHODS: RecipientPaymentMethod[] = [
  "ach",
  "wire",
  "internationalWire",
];

export const RECIPIENT_DRAWER_FLOW_CONFIG: Record<
  RecipientDrawerFlow,
  RecipientDrawerFlowConfig
> = {
  ach: {
    requiredMethod: "ach",
    afterSave: "close",
    missingMethodToastId: "add-ach-details-banner",
  },
  wire: {
    requiredMethod: "wire",
    afterSave: "close",
    missingMethodToastId: "wire-recipient-drawer-missing-wire-details",
  },
  internationalWire: {
    requiredMethod: "internationalWire",
    afterSave: "close",
    missingMethodToastId: "add-swift-details-error-banner",
  },
  settings: {
    requiredMethod: null,
    afterSave: "view",
    missingMethodToastId: null,
  },
};
